import React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useResponsiveScale } from '../../../contexts/ResponsiveScaleContext';
import { observer } from 'mobx-react-lite';
import { FullscreenPreviewContent } from '../../preview-content/fullscreen-preview-content/FullscreenPreviewContent';
import { PreviewModelInstance } from '../../../store/_models/preview';
import { TestIDs } from 'src/constants/testIDs.constants';
import { productPreviewTestID } from 'src/helpers/testIDs.helper';

type FramePreviewFullscreenProps = {
  preview: PreviewModelInstance;
  editable: boolean;
  showGrid: boolean;
  disabled?: boolean;
  disableSwapImageAnimation?: boolean;
};

const FullscreenPreview = observer(
  ({ preview, disabled, editable, showGrid, disableSwapImageAnimation = false }: FramePreviewFullscreenProps) => {
    const { containerResponsiveScaleSV } = useResponsiveScale();

    const sizeAnimatedStyle = useAnimatedStyle(() => ({
      width: preview.viewBox.width * containerResponsiveScaleSV.value,
      height: preview.viewBox.height * containerResponsiveScaleSV.value,
      alignItems: 'center',
      justifyContent: 'center',
    }));

    return (
      // PREVIEW CONTAINER
      <View
        style={[styles.previewContainer]}
        testID={productPreviewTestID(preview.userImageArea.productId, TestIDs.FULLSCREEN)}
      >
        <Animated.View style={sizeAnimatedStyle}>
          <FullscreenPreviewContent
            preview={preview}
            editable={editable}
            showGrid={showGrid}
            disabled={disabled}
            disableSwapImageAnimation={disableSwapImageAnimation}
          />
        </Animated.View>
      </View>
    );
  },
);

const styles = StyleSheet.create({
  previewContainer: {
    width: '100%',
    maxHeight: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default FullscreenPreview;
